import { request } from './client';

export const apiGetBooks = (params = '') => request(`/books?${params}`);

export const apiGetHomeBooks = () => request('/books/home');

export const apiGetBookById = (id) => request(`/books/${id}`);

export const apiGetLanguages = () => request('/books/languages/list');

export const apiGetPublishers = () => request('/books/publishers/list');
